import { errorHandler } from "./error.service";
import { http, URL } from "./http.service";

export const getGuestTrackings = async (businessUuid, params = {}) => {
  try {
    const queryString = new URLSearchParams(params).toString();
    const resp = await http.get(
      `${URL}/tracking/guest-trackings?businessUuid=${businessUuid}&${queryString}`
    );
    return resp.data;   // 👈 yaha sirf data return karo
  } catch (error) {
    errorHandler(error);
    throw error;        // 👈 important
  }
};